export const serviceTypeDict = [
  {
    code: 101,
    name: '代办值机'
  },
  {
    code: 102,
    name: '贵宾厅'
  },
  {
    code: 103,
    name: '安检通道'
  },
  {
    code: 110,
    name: '机场服务套餐'
  }
]

export const mallRechargeTypeDict = [
  {
    code: '011',
    name: '用户充值'
  },
  {
    code: '012',
    name: '手动充值'
  },
  {
    code: '501',
    name: '现金返还'
  },
  {
    code: '601',
    name: '返还-签证费收单'
  },
  {
    code: '101',
    name: '消费取消-机场服务-代办值机'
  },
  {
    code: '102',
    name: '消费取消-机场服务-贵宾厅'
  },

  {
    code: '103',
    name: '消费取消-机场服务-安检通道'
  },
  {
    code: '104',
    name: '消费取消-机场服务-全陪贵宾'
  },
  {
    code: '110',
    name: '消费取消-机场服务-套餐'
  },
  {
    code: '2',
    name: '消费取消-商城保险'
  },
  {
    code: '301',
    name: '消费取消-申根保险'
  },
  {
    code: '302',
    name: '消费取消-机票预定'
  },
  {
    code: '4',
    name: '退票-机票商城'
  },
]

export const mallExpenditureTypeDict = [
  {
    code: '0',
    name: '手动扣款'
  },
  {
    code: '5',
    name: '订单消费'
  },
  {
    code: '6',
    name: '下单-签证费收单'
  },
  {
    code: '101',
    name: '下单-机场服务-代办值机'
  },
  {
    code: '102',
    name: '下单-机场服务-贵宾厅'
  },
  {
    code: '103',
    name: '下单-机场服务-安检通道'
  },
  {
    code: '104',
    name: '下单-机场服务-全陪贵宾'
  },
  {
    code: '110',
    name: '下单-机场服务-套餐'
  },
  {
    code: '2',
    name: '下单-商城保险'
  },
  {
    code: '301',
    name: '下单-申根保险'
  },
  {
    code: '302',
    name: '下单-机票预订'
  },
  {
    code: '4',
    name: '下单-机票商城'
  },

  
]
